import { Box, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import CampoTextoIA from "../components/CampoTextoIA";
import GenerarProximosPasosButton from "src/components/propuesta/GenerarProximosPasosButton";

const StepInfoAdicional = ({ formik }) => (
  <Box>
    <Typography variant="h6" gutterBottom>
      Información Adicional
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
      Completa los últimos detalles de la propuesta antes de revisarla.
    </Typography>

    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} id="seccion-condicionesPago">
        <CampoTextoIA
          formik={formik}
          name="condicionesPago"
          label="Condiciones de pago"
          multiline
          minRows={3}
          placeholder="Ej: Pago mensual anticipado, transferencia bancaria..."
          contextIA="Condiciones de pago en una propuesta comercial tributaria chilena."
        />
      </Grid>

      <Grid item xs={12} sm={6} id="seccion-duracionEstimada">
        <CampoTextoIA
          formik={formik}
          name="duracionEstimada"
          label="Duración estimada"
          placeholder="Ej: 6 meses (implementación) + recurrente"
          helperText="Plazo global del proyecto. Es independiente de la duración de cada servicio."
        />
      </Grid>

      <Grid item xs={12} id="seccion-proximosPasos">
        <CampoTextoIA
          formik={formik}
          name="proximosPasos"
          label="Próximos pasos"
          multiline
          minRows={3}
          placeholder="Ej: Firma del contrato, solicitud de documentos, inicio de servicios..."
          contextIA="Onboarding del cliente tras aceptar la propuesta comercial tributaria."
          helperText="Formato sugerido: cada paso en su propia línea (título corto + descripción 1-2 oraciones). Separa pasos con una línea en blanco. Máximo 5 pasos. Si lo dejas como prosa libre, se renderizará igualmente pero sin la numeración visual."
          endActions={
            <GenerarProximosPasosButton
              items={formik.values.items}
              solicitanteNombre={
                formik.values.solicitanteData?.nombre ||
                formik.values.solicitanteNuevo?.nombre
              }
              sucursal={formik.values.sucursal}
              proximosPasos={formik.values.proximosPasos}
              onGenerated={(texto) =>
                formik.setFieldValue("proximosPasos", texto)
              }
            />
          }
        />
      </Grid>

      <Grid item xs={12}>
        <CampoTextoIA
          formik={formik}
          name="clausulaConfidencialidad"
          label="Cláusula de confidencialidad"
          multiline
          minRows={5}
          helperText="Texto que aparecerá como cláusula de confidencialidad al final del PDF. Edítalo si necesitas ajustarlo al contexto del cliente."
          contextIA="Cláusula de confidencialidad en una propuesta comercial tributaria chilena."
        />
      </Grid>
    </Grid>
  </Box>
);

StepInfoAdicional.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default StepInfoAdicional;
